require('./insuranceRequestWizard.override.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @ utilities
const { formatText } = require('core/i18n').i18n;
const { toFirstUppercase } = require('utilities/stringHelper');
const { PROC_STEP, recordProcess } = require('utilities/tagging');

// @ commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const OKModal = require('components/commons/OKModal/OKModal');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');

// @ components
const { CallMeBack } = require('components/callMeBack/callMeBack');
const InsuranceRequestCompilationCard = require('../../components/insuranceRequestCompilationCard/insuranceRequestCompilationCard');
const InsuranceRequestWizardStep1 = require('./insuranceRequestWizardStep1/insuranceRequestWizardStep1');
const InsuranceRequestWizardStep2 = require('./insuranceRequestWizardStep2/insuranceRequestWizardStep2');
const InsuranceRequestWizardStep3 = require('./insuranceRequestWizardStep3/insuranceRequestWizardStep3');
const InsuranceRequestWizardStep3CC = require('./insuranceRequestWizardStep3/insuranceRequestWizardStep3CC');
const InsuranceRequestWizardStep4 = require('./insuranceRequestWizardStep4/insuranceRequestWizardStep4');
const InsuranceRequestWizardStep5 = require('./insuranceRequestWizardStep5/insuranceRequestWizardStep5');
const InsuranceRequestWizardRequestSuccess = require('./insuranceRequestWizardRequestSuccess/insuranceRequestWizardRequestSuccess');
const InsuranceRequestWizardRequestError = require('./insuranceRequestWizardRequestError/insuranceRequestWizardRequestError');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');
const InsuranceRequestDetailsTabsWrapper = require('../insuranceRequestDetails/insuranceRequestDetailsTabsWrapper');
const CoverageWrapper = require('../insuranceRequestDetailsContactCenter/coverageWrapper');

// @ constants
const { PROC_INSURANCE_HOME, PRODUCT_NAME_HOME_INSURANCE, getInsuranceTag } = require('../../insuranceConstants/insuranceRequestTags');
const ROUTES = require('../../insuranceConstants/insuranceRequestRoutes');
const { COMMONS: { PRESTAMOS_PHONE } } = require('constants/mortgageRequestHolderData');
const {
    CC_INSURANCE_SEND_MAIL_CODES,
    PLANS: { BASIC },
    WIZARD_REQUEST_RESPONSE_ERROR_CODES: { ALREADY_INSURED_ADDRESS },
    WIZARD_REQUEST_RESPONSE_OPTIONS,
} = require('../../insuranceConstants/insuranceRequestHome');
const { SECOND_STEP, THIRD_STEP, FOURTH_STEP, FIFTH_STEP } = require('constants/index');
const {
    INSURANCE_USABILITY_IMPROVEMENTS,
    INSURANCES_PERFORMANCE_LIMITS,
    STANDALONE_RELATED_INSURANCE,
} = require('constants/flagBasedFeatures');
const { SUCCESS, ERROR, IS_FETCHING } = WIZARD_REQUEST_RESPONSE_OPTIONS;
// @constants
const {
    ACCESS,
    PORTABILITY,
} = require('constants/index');

// @ actions
const insuranceRequestStateActions = require('../../actions/insuranceRequest/insuranceRequestState');
const insuranceRequestWizardActions = require('../../actions/insuranceRequest/insuranceRequestWizard');
const insuranceLegalDocumentsActions = require('../../actions/insuranceLegalDocuments');
const insuranceRequestActionsWizardStep4 = require('../../actions/insuranceRequest/insuranceRequestWizardStep4');
const insuranceChosenMortgageActions = require('../../actions/insuranceChosenMortgage');
const { getInsuranceAssociatedMortgage } = require('../../actions/insuranceAssociatedMortgage');
const insurancesLandingActions = require('../../actions/insuranceRequest/insuranceRequestLanding');

const blockedAccountsActions = require('actions/blockedAccounts');
const preContractualMailActions = require('actions/preContractualMailInfo');
const profileActions = require('actions/profile');
const rightsProfileActions = require('actions/rightsProfile');

class InsuranceRequestWizard extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            didPlanChangeIndetailTable: false,
            selectedPlan: BASIC,
            showCoverageDetailTable: false,
            selectedValue: '',
            showModal: false,
            buttonModalDisabled: true,
            dataModal: [],
            hasErrorInsurance: false,
            isLoading: false,
        };

        this.isReady = this.isReady.bind(this);
        this.handleConfirmLeave = this.handleConfirmLeave.bind(this);
        this.beforeLeaving = this.beforeLeaving.bind(this);
        this.onHandleCancel = this.onHandleCancel.bind(this);
        this.handleChangeShowCoverageDetailTable = this.handleChangeShowCoverageDetailTable.bind(this);
        this.onhandleSelectPlanInDetailTable = this.onhandleSelectPlanInDetailTable.bind(this);
        this.onhandleChangeSelectedPlan = this.onhandleChangeSelectedPlan.bind(this);
        this.recordEvent = this.recordEvent.bind(this);
        this.onAgreementCheckboxChange = this.onAgreementCheckboxChange.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleRadioGroupChange = this.handleRadioGroupChange.bind(this);
        this.handlePrimaryButtonClick = this.handlePrimaryButtonClick.bind(this);
        this.handleValidation = this.handleValidation.bind(this);
    }

    componentWillMount() {
        const {
            getAddressTypeList,
            getInsurance,
            immInsuranceState,
            loadSteps,
            resetPrecontractualMail,
        } = this.props;

        if (immInsuranceState.get('data')) {
            loadSteps(immInsuranceState.get('data').toJS());
        } else {
            getInsurance(true);
        }
        getAddressTypeList();

        if (__CONTACT_CENTER__) {
            resetPrecontractualMail();
        }
    }

    componentDidMount() {
        const { insuranceRequestFreeStarted } = this.props;
        insuranceRequestFreeStarted();
    }

    componentWillReceiveProps(nextProps) {
        const { immInsuranceState, loadSteps } = this.props;

        if (nextProps.immInsuranceState.get('data') !== immInsuranceState.get('data')) {
            loadSteps(nextProps.immInsuranceState.get('data').toJS());
        }

        if (nextProps.immInsuranceWizard.get('visibleStep') === FIFTH_STEP) {
            this.setState({
                showCoverageDetailTable: false,
            });
        }
    }

    componentDidUpdate(prevProps) {
        const {immInsuranceAssociatedMortgage, immInsurances} = this.props;
        if (prevProps.immInsurances !== immInsurances) {
            if (immInsuranceAssociatedMortgage.get('success') && immInsurances.get('fulfilled')) {
                this.checkDataInsurance();
            }
        }
    }

    componentWillUnmount() {
        this.props.clearRequest();
    }

    hasSimulation() {
        const { immInsuranceState } = this.props;

        return immInsuranceState.get('data') !== null && !immInsuranceState.get('data').isEmpty();
    }

    hasSimulationChanged() {
        const { immInsuranceWizard } = this.props;

        return immInsuranceWizard.getIn(['steps', SECOND_STEP, 'simulationChanged']);
    }

    handleConfirmLeave() {
        const redirectTo = ROUTES.INSURANCES_LANDING;
        this.props.clearRequest();
        this.props.history.push(redirectTo);
    }

    beforeLeaving() {
        this.props.clearRequest();
    }

    isReady() {
        const { immInsuranceWizard } = this.props;
        const isFirstStep = immInsuranceWizard.get('visibleStep') === 1;
        const wizardSuccess = immInsuranceWizard.get('wizardRequestResponse') === SUCCESS;
        const wizardError = immInsuranceWizard.get('wizardRequestResponse') === ERROR;
        const wizardResponseIsFetching = immInsuranceWizard.get('wizardRequestResponse') === IS_FETCHING;
        return (
            wizardError ||
            wizardResponseIsFetching ||
            wizardSuccess ||
            isFirstStep
        );
    }

    onHandleCancel() {
        const redirectTo = ROUTES.INSURANCES_LANDING;
        this.props.history.push(redirectTo);
    }

    handleChangeShowCoverageDetailTable() {
        this.setState({
            showCoverageDetailTable: !this.state.showCoverageDetailTable
        })
    }

    onhandleChangeSelectedPlan(selectedPlan, didChange = true) {
        this.setState({
            didPlanChangeIndetailTable: didChange,
            selectedPlan,
        })
    }

    onhandleSelectPlanInDetailTable(selectedPlanInDetailTable) {
        const { insuranceSelectPlan } = this.props;
        insuranceSelectPlan(selectedPlanInDetailTable, true)
    }

    insuranceRequestBuildAddress(immStep4) {
        const roadTypeName = immStep4.get('roadTypeName');
        const addressRoad = immStep4.get('road');
        const addressNumber = immStep4.get('number');
        const roadTypeNameUpper = roadTypeName ? toFirstUppercase(roadTypeName) : '';
        const addressNumberShow = addressNumber === 's/n' || addressNumber === 'S/N' || !addressNumber ? '' : `, ${addressNumber}`;

        return `${roadTypeNameUpper} ${addressRoad}${addressNumberShow}`;
    }

    recordEvent(event, extraTag) {
        const { immInsuranceWizard } = this.props;

        const step = PROC_STEP + immInsuranceWizard.get('visibleStep');
        recordProcess(PROC_INSURANCE_HOME, step, getInsuranceTag(event, extraTag))
    }

    getProductName() {
        const insuranceData = this.props.immInsuranceState.get('data');
        const insurancePlan = insuranceData && insuranceData.toJS().insurancePlan
        const productName = PRODUCT_NAME_HOME_INSURANCE[insurancePlan]
        return `home${productName || ""}`
    }

    onAgreementCheckboxChange(evt) {
        const { setData } = this.props;
        setData(FIFTH_STEP, { agreementChecked: evt.target.checked });
    }

    buildPreLeaveModal() {
        const { immInsuranceWizard } = this.props;

        const visibleStep = immInsuranceWizard.get('visibleStep');
        const confirmationMessageTitle = formatText('insuranceRequestHome-confirmationMessageTitle');
        const confirmationAcceptText = formatText('insuranceRequestHome-confirmationAcceptText');
        const confirmationCancelText = formatText('insuranceRequestHome-confirmationCancelText');
        let confirmationMessage = formatText('insuranceRequestHome-confirmationMessage');

        if (visibleStep >= 4) {
            confirmationMessage = formatText('insuranceRequestHome-confirmationMessageLast');
        }

        return (
            <PreLeaveModalComponent
                acceptText={confirmationAcceptText}
                beforeLeaving={this.beforeLeaving}
                cancelText={confirmationCancelText}
                confirmationMessage={confirmationMessage}
                confirmationTitle={confirmationMessageTitle}
                isReady={this.isReady}
                onConfirmLeave={this.handleConfirmLeave}
            />
        );
    }

    getCoverageWrapperProps() {
        const {
            immFlagBasedFeatures,
            immInsuranceState,
            immInsuranceWizard,
            linkClientSuccessInitialState,
            setData,
            validateStep,
        } = this.props;

        const immInsuranceWizardStep3 = immInsuranceWizard.getIn(['steps', THIRD_STEP]);
        const currentPlan = immInsuranceWizardStep3.get('insurancePlan');

        return {
            currentPlan,
            didPlanChangeIndetailTable: this.state.didPlanChangeIndetailTable,
            immFlagBasedFeatures,
            immInsuranceState,
            immInsuranceWizard,
            linkClientSuccessInitialState,
            onChangeShowCoverageDetailTable: this.handleChangeShowCoverageDetailTable,
            onhandleCancel: this.onHandleCancel,
            onhandleChangeSelectedPlanInStateComponent: this.onhandleChangeSelectedPlan,
            onhandleSelectPlanInDetailTable: this.onhandleSelectPlanInDetailTable,
            selectedPlan: this.state.selectedPlan,
            setData,
            validateStep,
        };

    }

    buildContactCenterCoverageWrapper() {
        const preLeaveModalComponent = this.buildPreLeaveModal();
        const coverageWrapperProps = this.getCoverageWrapperProps();

        return (
            <React.Fragment>
                <CoverageWrapper
                    {...coverageWrapperProps}
                />
                {preLeaveModalComponent}
            </React.Fragment>
        );
    }

    buildNormalCoverageWrapper() {
        const preLeaveModalComponent = this.buildPreLeaveModal();
        const coverageWrapperProps = this.getCoverageWrapperProps();

        return (
            <React.Fragment>
                <InsuranceRequestDetailsTabsWrapper
                    {...coverageWrapperProps}
                />
                {preLeaveModalComponent}
            </React.Fragment>
        );
    }

    buildCoverageWrapper() {
        const { immFlagBasedFeatures } = this.props;
        let coverageWrapper = null;
        const webActuationLimitsIsEnabled = immFlagBasedFeatures.get(INSURANCES_PERFORMANCE_LIMITS);

        if (__CONTACT_CENTER__ && webActuationLimitsIsEnabled) {
            coverageWrapper = this.buildContactCenterCoverageWrapper();
        } else {
            coverageWrapper = this.buildNormalCoverageWrapper();
        }

        return coverageWrapper;
    }

    buildInsuranceRequestStep3() {
        const {
            getCoveragesAndPlansData,
            getCoveragesAndPlansDetailsData,
            getQuotationData,
            immAccounts,
            immFlagBasedFeatures,
            immInsuranceState,
            immInsuranceWizard,
            insuranceSelectPlan,
            linkClientSuccessInitialState,
            setData,
            validateStep,
        } = this.props;

        const step3Props = {
            getCoveragesAndPlansData,
            getCoveragesAndPlansDetailsData,
            getQuotationData,
            hasSimulationChanged: this.hasSimulationChanged(),
            immAccounts,
            immFlagBasedFeatures: immFlagBasedFeatures,
            immInsuranceState,
            immInsuranceWizard,
            insuranceSelectPlan,
            linkClientSuccessInitialState,
            onChangeShowCoverageDetailTable: this.handleChangeShowCoverageDetailTable,
            recordEvent: this.recordEvent,
            setData,
            validateStep,
            webActuationLimitsIsEnabled: immFlagBasedFeatures.get(INSURANCES_PERFORMANCE_LIMITS),
        }
        return __CONTACT_CENTER__ ?
            (<InsuranceRequestWizardStep3CC
                {...step3Props}
            />) :
            (<InsuranceRequestWizardStep3
                {...step3Props}
            />);
    }

    buildRadioGroupMortgage() {
        let radioButtons = [];
        this.state.dataModal.forEach(option => {
            radioButtons.push(this.buildRadioButtonMortgage(option));
        });

        return (
            <div>
                <RadioButtonGroup
                    idPrefix="propertyUsageRadioGroup"
                    name="propertyUsageRadioGroup"
                    onChange={value => this.handleRadioGroupChange('propertyUsage', value)}
                    selectedValue={this.state.selectedValue}
                >
                    {radioButtons}
                </RadioButtonGroup>
            </div>
        );
    }

    buildRadioButtonMortgage(option) {
        return (
            <RadioButton
                label={option.label}
                value={option.value}
                key={option.label}
                className="block-step__radio"
            />
        );
    }

    handleRadioGroupChange(key, value) {
        const data = this.getDataInsuranceHogarOpen();
        const chosenMortgage = data.find(item => item.value === value);
        this.props.setInsuranceChosenMortgage(chosenMortgage);

        this.setState({
            buttonModalDisabled: false,
            selectedValue: value
        });
    }

    handlePrimaryButtonClick(){
        const { validateStep } = this.props;
        this.setState({
            selectedValue: '',
            showModal: false,
            buttonModalDisabled: true,
        });
        validateStep(1);
    }

    handleCloseModal() {
        this.props.history.push('/myprofile/insurances');
    }

    getAssociatedInsurance(mortgage) {
        const {immInsuranceAssociatedMortgage} = this.props;
        const insuranceAssociatedMortgage = immInsuranceAssociatedMortgage.get('insuranceAssociatedMortgage');
        let associatedInsurance = null;

        if (insuranceAssociatedMortgage.toJS().length > 0) {
            associatedInsurance = insuranceAssociatedMortgage.toJS().filter((item) => {
                return item.mortgageContractNumber === mortgage.contractNumber
            });
        }

        return associatedInsurance;
    }

    getMortgagesContracted() {
        const {immRightsProfile} = this.props
        const productsUser = immRightsProfile.getIn(['productsUser']);
        const datosSalidaPrestamos = productsUser.datosSalidaPrestamos

        if(!datosSalidaPrestamos) return [];

        const prestamos = datosSalidaPrestamos.prestamos;
        const filteredType = prestamos.filter(({cnuevo}) => cnuevo.producto === "103");
        const filteredSubType = filteredType.filter(
            ({criterios}) =>
                criterios.c1.subtipoproducto !== '801' &&
                criterios.c1.subtipoproducto !== '802' &&
                criterios.c1.subtipoproducto !== '803'
        )

        return filteredSubType.map( mortgage => {
            return {
                alias: mortgage.descripcion,
                contractNumber: mortgage.cnuevo.numerodecontrato,
            }
        });
    }

    getInsurancesInMortgage(mortgagesContracted) {
        let insurancesInMortgage = [];

        for (const mortgage of mortgagesContracted) {
            insurancesInMortgage.push(...this.getAssociatedInsurance(mortgage));
        }

        return insurancesInMortgage;
    }

    getInsurancesWithPolicy(insurancesInMortgage) {
        const { immInsurances } = this.props;
        const insurances = immInsurances.get('insurances').toJS();
        let insurancesWithPolicy = [];

        if (insurances && insurances.length > 0) {
            for (const insurance of insurances) {
                for (const associated of insurancesInMortgage) {
                    if (associated.policyCode === insurance.policyNumber && insurance.policyStatus === 'VIGOR') {
                        insurancesWithPolicy.push(associated);
                    }
                }
            }
        }

        return insurancesWithPolicy;
    }

    getDataToRadioGroup(mortgages) {
        let data = mortgages.map((mortgage, index) => {
            return {
                label: `${formatText('insuranceRequestHome-modalHogarOpenRBLabel')} ${mortgage.alias}`,
                value: String(index+1),
                contractNumber: mortgage.contractNumber,
            }
        });

        const anotherHome = {
            label: formatText('insuranceRequestHome-modalHogarOpenDefault'),
            value: '0',
        };

        return data.length > 0 ? [...data, anotherHome] : null;
    }

    getMortgagesNoPolicy(insurancesWithPolicy, mortgagesContracted) {
        let mortgages = [];

        for (const insurance of insurancesWithPolicy) {
            for (const mortgage of mortgagesContracted) {
                if(insurance.mortgageContractNumber !== mortgage.contractNumber){
                    mortgages.push(mortgage);
                }
            }
        }

        return mortgages.length > 0 ? mortgages : null;
    }

    getDataInsuranceHogarOpen() {
        const mortgagesContracted = this.getMortgagesContracted();
        let dataToRadioGroup;

        if(mortgagesContracted.length > 0) {
            dataToRadioGroup = this.getDataToRadioGroup(mortgagesContracted);
            const insurancesInMortgage = this.getInsurancesInMortgage(mortgagesContracted);

            if(insurancesInMortgage.length > 0) {
                const insurancesWithPolicy = this.getInsurancesWithPolicy(insurancesInMortgage);

                if(insurancesWithPolicy.length > 0) {
                    const mortgagesNoPolicy = this.getMortgagesNoPolicy(insurancesWithPolicy, mortgagesContracted);
                    dataToRadioGroup = mortgagesNoPolicy ? this.getDataToRadioGroup(mortgagesNoPolicy) : [];
                }

            }
        }

        return dataToRadioGroup;
    }

    buildModalInsuranceHogarOpen() {
        const title = formatText('insuranceRequestHome-modalHogarOpenTitle');
        const primaryButtonText = formatText('insuranceRequestHome-modalHogarOpenConfirm');
        const secondaryButtonText = formatText('insuranceRequestHome-modalHogarOpenCancel');
        const information = formatText('insuranceRequestHome-modalHogarOpenInformation');
        const content = this.buildRadioGroupMortgage();

        return content && (
            <OKModal
                content={content}
                description={information}
                footerType="navigation"
                isOpen={this.state.showModal}
                primaryButtonDisabled={this.state.buttonModalDisabled}
                onPrimaryButtonClick={this.handlePrimaryButtonClick}
                onCloseCallback={this.handleCloseModal}
                onSecondaryButtonClick={this.handleCloseModal}
                primaryButtonText={primaryButtonText}
                secondaryButtonText={secondaryButtonText}
                title={title}
            />
        )
    }

    loadInsuranceServices() {
        const {getRights, getInsuranceAssociatedMortgage, requestInsurancesOverallView} = this.props;
        getRights(([ACCESS, PORTABILITY]))
        getInsuranceAssociatedMortgage();
        requestInsurancesOverallView();
    }

    isErrorInsuranceServices() {
        const {immRightsProfile, immInsuranceAssociatedMortgage, immInsurances} = this.props;
        const hasErrorProfile = immRightsProfile.get('error');
        const hasErrorInsuranceAssociatedMortgage = immInsuranceAssociatedMortgage.get('error');
        const hasErrorInsurance = immInsurances.get('error');

        return (hasErrorProfile || hasErrorInsuranceAssociatedMortgage || hasErrorInsurance);
    }

    handleValidation(step) {
        if (step === 1) {
            this.setState({isLoading: true})
            this.loadInsuranceServices();
        }
    }

    checkDataInsurance() {
        if (!this.isErrorInsuranceServices()) {
            const {validateStep} = this.props;
            const dataModal = this.getDataInsuranceHogarOpen();
            if (dataModal && dataModal.length > 0) {
                this.setState({showModal: true, isLoading: false, dataModal})
            } else {
                this.setState({isLoading: false});
                validateStep(1);
            }
        } else {
            this.setState({hasErrorInsurance: true});
        }
    }

    render() {
        const {
            changeErrorPopulation,
            changeErrorPostalCode,
            clearPostalCodeError,
            getAddressTypeList,
            getBlockedAccounts,
            getDocument,
            getDocumentsSummary,
            getDocumentsZip,
            getMortgageBanks,
            getPaymentAccount,
            getPopulationData,
            getRecommendation,
            immAccounts,
            immFlagBasedFeatures,
            immInsuranceLegalDocuments,
            immInsuranceState,
            immInsuranceWizard,
            immPreContractualMail,
            immProfile,
            immInsuranceChosenMortgage,
            onPrintDocument,
            requestInsuranceProvinces,
            requestProfile,
            resetBlockedAccounts,
            resetPrecontractualMail,
            saveStep,
            sendPreContractualMail,
            setData,
            setVisibleStep,
            setWillCancel,
            insuranceRequestFreeStarted,
            insuranceRequesCombinedStarted,
            validateStep,
            checkReadDocument,
        } = this.props;

        const { showCoverageDetailTable, hasErrorInsurance } = this.state;

        const wizardRequestResponse = immInsuranceWizard.get('wizardRequestResponse');
        const immInsuranceWizardStep2 = immInsuranceWizard.getIn(['steps', SECOND_STEP]);
        const immInsuranceWizardStep3 = immInsuranceWizard.getIn(['steps', THIRD_STEP]);
        const immInsuranceWizardStep4 = immInsuranceWizard.getIn(['steps', FOURTH_STEP]);
        const immInsuranceWizardStep5 = immInsuranceWizard.getIn(['steps', FIFTH_STEP]);
        const serviceError = immInsuranceState.get('error') ||
            immInsuranceWizardStep3.get('errorDetails') ||
            immInsuranceWizardStep3.get('errorQuotation') ||
            immInsuranceWizardStep3.get('cancelError') ||
            immInsuranceWizardStep3.get('error') ||
            immInsuranceWizardStep3.get('errorSelectPlan') ||
            immInsuranceWizardStep3.get('linkingError') ||
            immInsuranceWizardStep4.get('errorPricing') ||
            immInsuranceWizardStep4.get('errorSave') ||
            immInsuranceWizardStep4.get('errorPayment') ||
            hasErrorInsurance;

        const sendMailParams = {
            id: immInsuranceState.getIn(['data', 'id']),
            code: CC_INSURANCE_SEND_MAIL_CODES.HOME_INSURANCE_REQUEST,
        };

        let operativeName;
        if (__CONTACT_CENTER__) {
            operativeName = 'operatives-non_combined_home_insurance';
        }

        const baseActions = {
            cancel: this.onHandleCancel,
            finish: () => { },
            setVisibleStep,
            setWillCancel,
        }
        const isEnabledFFStandalone = immFlagBasedFeatures.get(STANDALONE_RELATED_INSURANCE);
        const wizardActions = { ...baseActions, validateStep: (immInsuranceWizard.get('visibleStep') === 1 && isEnabledFFStandalone) ? this.handleValidation : validateStep }

        const associatingClient = immInsuranceWizardStep3.get('isFetchingSelectPlan') || immInsuranceWizardStep3.get('isLinkingInProgress');
        const isFetchingRecomendation = immInsuranceState.get('isFetchingRecommendation');
        const isInsuranceUsabilityImprovementsEnabled = immFlagBasedFeatures.get(INSURANCE_USABILITY_IMPROVEMENTS);
        const step2NextButtonDisabled = isFetchingRecomendation || (isInsuranceUsabilityImprovementsEnabled && !immInsuranceWizardStep2.get('valid'));
        const preLeaveModalComponent = this.buildPreLeaveModal();
        const modalInsuranceHogarOpen = this.buildModalInsuranceHogarOpen();

        if (wizardRequestResponse === SUCCESS) {
            const policyDocument = immInsuranceWizard.get('policyDocument');

            return (
                <InsuranceRequestWizardRequestSuccess
                    getDocument={getDocument}
                    hasSimulation={this.hasSimulation()}
                    hasSimulationChanged={this.hasSimulationChanged()}
                    immAccounts={immAccounts}
                    immInsuranceState={immInsuranceState}
                    immInsuranceWizardState={immInsuranceWizard}
                    isRelated={false}
                    policyPdfBase64={policyDocument.get('policyPdfBase64')}
                    policyPdfName={policyDocument.get('policyPdfName')}
                    policyPdfType={policyDocument.get('policyPdfType')}
                    policyPdfUrl={policyDocument.get('policyPdfUrl')}
                    productName={this.getProductName()}
                />
            );
        } else if (showCoverageDetailTable) {
            return this.buildCoverageWrapper();
        } else if (wizardRequestResponse === ERROR) {

            let errorTitle = formatText('insuranceRequestHome-step5TitleError');
            let errorText = formatText('insuranceRequestHome-step5ErrorText', [PRESTAMOS_PHONE]);
            let secondaryButtonLabel = '';
            let secondaryButtonLink = '';

            const errorList = immInsuranceWizard.getIn(['error', 'errorList']);
            const addressInsuredError = errorList && errorList.toJS().some(e => e.error === ALREADY_INSURED_ADDRESS);


            if (addressInsuredError) {
                const address = this.insuranceRequestBuildAddress(immInsuranceWizardStep4);
                errorTitle = formatText('insuranceRequestError-existingAddressErrorTitle');
                errorText = formatText('insuranceRequestError-existingAddressErrorMessage', [address]);
                secondaryButtonLabel = formatText('insuranceRequestError-existingAddressErrorSecondaryButtonLabel');
                secondaryButtonLink = ROUTES.INSURANCES_HOME_REQUEST;
            }

            return (
                <InsuranceRequestWizardRequestError
                    buttonLabel={formatText('insuranceRequestHome-step5TryAgainLink')}
                    buttonLink={formatText('insuranceRequestHome-step5TryAgainLinkURL')}
                    secondaryButtonLabel={secondaryButtonLabel}
                    secondaryButtonLink={secondaryButtonLink}
                    text={errorText}
                    title={errorTitle}
                />
            );
        } else if (serviceError) {
            return <InsuranceRequestWizardRequestError />;
        }

        const tealiumName = [
            "start",
            "simulator",
            "selector",
            "address",
            "confirmation",
        ][immInsuranceWizard.get("visibleStep") - 1];
        const tealiumStep = [0, 1, 2, 1, 2][
            immInsuranceWizard.get("visibleStep") - 1
        ];
        const productName = this.getProductName();
        const processType = immInsuranceWizard.get("visibleStep") <= 3 ? "homeInsurancesSimulation" : "homeInsurancesContracting";
        const tealiumData = {
            event_name: `step_${tealiumName}`,
            pageName: `/${processType}/step${tealiumStep}/${tealiumName}`,
            sectionFamily: "banking",
            sectionCategory: "products",
            sectionName: "insurances",
            serviceType: "productContracting",
            interactionType: "funnel",
            processType,
            processStep: `step${tealiumStep}`,
            processDetail: `${tealiumName}`,
            productName,
        };
        const tealiumEvents = {
            next: {
                event_name: "event_success",
                action: "success",
                format: "steps",
                component: "funnel",
                element: `${tealiumName}`,
                get data() {
                    return true;
                },
            },
        };

        return (
            <div className="insurance-request-wizard row">
                <div className="col-xs-12 col-md-8">
                    <Wizard
                        actions={wizardActions}
                        immSteps={immInsuranceWizard.get("steps")}
                        isFetching={false}
                        stepsAmount={immInsuranceWizard.get("steps").size}
                        visibleStep={immInsuranceWizard.get("visibleStep")}
                        tealium={tealiumData}
                        isTaggingSecondVersion
                        tealiumEvents={tealiumEvents}
                    >
                        <WizardStep
                            cancelButton={true}
                            position="first"
                            isLoading={this.state.isLoading}
                        >
                            <InsuranceRequestWizardStep1 />
                        </WizardStep>
                        <WizardStep
                            addLoadingBehaviour={false}
                            cancelButton={true}
                            nextButton={true}
                            nextButtonDisabled={step2NextButtonDisabled}
                            position="middle"
                            previousButton={true}
                        >
                            <InsuranceRequestWizardStep2
                                changeErrorPopulation={changeErrorPopulation}
                                changeErrorPostalCode={changeErrorPostalCode}
                                clearPostalCodeError={clearPostalCodeError}
                                getPopulationData={getPopulationData}
                                getRecommendation={getRecommendation}
                                immFlagBasedFeatures={immFlagBasedFeatures}
                                immInsuranceState={immInsuranceState}
                                insuranceRequestFreeStarted={insuranceRequestFreeStarted}
                                insuranceRequesCombinedStarted={insuranceRequesCombinedStarted}
                                immInsuranceWizardStep={immInsuranceWizardStep2}
                                immInsuranceChosenMortgage={immInsuranceChosenMortgage}
                                recordEvent={this.recordEvent}
                                setData={setData}
                            />
                        </WizardStep>
                        <WizardStep
                            addLoadingBehaviour={false}
                            cancelButton={true}
                            isLoading={associatingClient}
                            nextButton={true}
                            position="middle"
                            previousButton={true}
                        >
                            {this.buildInsuranceRequestStep3()}
                        </WizardStep>
                        <WizardStep
                            addLoadingBehaviour={false}
                            cancelButton={true}
                            isLoading={immInsuranceWizardStep4.get('setPaymentAccountInProgress') || immInsuranceWizardStep4.get('isSaving')}
                            nextButton={true}
                            position="middle"
                            previousButton={true}
                        >
                            <InsuranceRequestWizardStep4
                                getAddressTypeList={getAddressTypeList}
                                getBlockedAccounts={getBlockedAccounts}
                                getMortgageBanks={getMortgageBanks}
                                getPaymentAccount={getPaymentAccount}
                                goBackStep={setVisibleStep}
                                immAccounts={immAccounts}
                                immFlagBasedFeatures={immFlagBasedFeatures}
                                immInsuranceState={immInsuranceState}
                                immInsuranceWizardStep={immInsuranceWizardStep4}
                                immInsuranceChosenMortgage={immInsuranceChosenMortgage}
                                postalCode={immInsuranceWizardStep2.get('postalCode')}
                                requestInsuranceProvinces={requestInsuranceProvinces}
                                resetBlockedAccounts={resetBlockedAccounts}
                                saveStep={saveStep}
                                setData={setData}
                            />
                        </WizardStep>
                        <WizardStep
                            addLoadingBehaviour={true}
                            cancelButton={true}
                            finishButton={false}
                            immFinalButton="common-confirm"
                            isLoading={wizardRequestResponse === IS_FETCHING}
                            position="last"
                            previousButton={true}
                        >
                            <InsuranceRequestWizardStep5
                                contractName={operativeName}
                                getAddressTypeList={getAddressTypeList}
                                getDocument={getDocument}
                                getDocumentsSummary={getDocumentsSummary}
                                getDocumentsZip={getDocumentsZip}
                                getPaymentAccount={getPaymentAccount}
                                handleAgreementCheckboxChange={this.onAgreementCheckboxChange}
                                hasSimulation={this.hasSimulation()}
                                hasSimulationChanged={this.hasSimulationChanged()}
                                immAccounts={immAccounts}
                                immFlagBasedFeatures={immFlagBasedFeatures}
                                immInsuranceLegalDocuments={immInsuranceLegalDocuments}
                                immInsuranceState={immInsuranceState}
                                immInsuranceWizardPrevStep={immInsuranceWizardStep4}
                                immInsuranceWizardState={immInsuranceWizard}
                                immInsuranceWizardStep={immInsuranceWizardStep5}
                                immPreContractualMail={immPreContractualMail}
                                immProfile={immProfile}
                                onPrintDocument={onPrintDocument}
                                requestProfile={requestProfile}
                                resetPrecontractualMail={resetPrecontractualMail}
                                sendMailParams={sendMailParams}
                                sendPreContractualMail={sendPreContractualMail}
                                setData={setData}
                                checkReadDocument={checkReadDocument}
                            />
                        </WizardStep>
                    </Wizard>
                </div>
                <div className="col-xs-12 col-md-4">
                    <div className="col-xs-12 col-sm-6 col-md-12 grid-view--variable-cell-separation">
                        <InsuranceRequestCompilationCard
                            hasSimulation={this.hasSimulation()}
                            hasSimulationChanged={this.hasSimulationChanged()}
                            immInsuranceState={immInsuranceState}
                            immInsuranceWizardState={immInsuranceWizard}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-6 col-md-12 grid-view--variable-cell-separation">
                        <CallMeBack hasEntrance={false} />
                    </div>
                </div>
                {preLeaveModalComponent}
                {modalInsuranceHogarOpen}
            </div>
        );
    }
}

InsuranceRequestWizard.propTypes = {
    changeErrorPopulation: PropTypes.func.isRequired,
    changeErrorPostalCode: PropTypes.func.isRequired,
    clearPostalCodeError: PropTypes.func.isRequired,
    clearRequest: PropTypes.func.isRequired,
    getAddressTypeList: PropTypes.func.isRequired,
    getBlockedAccounts: PropTypes.func.isRequired,
    getCoveragesAndPlansData: PropTypes.func.isRequired,
    getCoveragesAndPlansDetailsData: PropTypes.func.isRequired,
    getDocument: PropTypes.func.isRequired,
    getDocumentsSummary: PropTypes.func.isRequired,
    getDocumentsZip: PropTypes.func.isRequired,
    getInsurance: PropTypes.func.isRequired,
    getMortgageBanks: PropTypes.func.isRequired,
    getPaymentAccount: PropTypes.func.isRequired,
    getPopulationData: PropTypes.func.isRequired,
    getQuotationData: PropTypes.func.isRequired,
    getRecommendation: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immInsuranceLegalDocuments: PropTypes.object.isRequired,
    immInsuranceState: PropTypes.object.isRequired,
    immInsuranceWizard: PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object,
    immProfile: PropTypes.object.isRequired,
    immRightsProfile: PropTypes.object,
    immInsuranceAssociatedMortgage: PropTypes.object,
    immInsurances: PropTypes.object,
    immInsuranceChosenMortgage: PropTypes.object,
    insuranceSelectPlan: PropTypes.func.isRequired,
    insuranceRequestFreeStarted: PropTypes.func.isRequired,
    insuranceRequesCombinedStarted: PropTypes.func.isRequired,
    linkClientSuccessInitialState: PropTypes.func.isRequired,
    loadSteps: PropTypes.func.isRequired,
    onPrintDocument: PropTypes.func.isRequired,
    requestInsuranceProvinces: PropTypes.func.isRequired,
    requestProfile: PropTypes.func,
    resetBlockedAccounts: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func,
    saveStep: PropTypes.func.isRequired,
    sendPreContractualMail: PropTypes.func,
    setData: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    setInsuranceChosenMortgage: PropTypes.func.isRequired,
    getInsuranceAssociatedMortgage: PropTypes.func.isRequired,
    requestInsurancesOverallView: PropTypes.func.isRequired,
    getRights: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
};

module.exports.constructor = InsuranceRequestWizard;

module.exports.InsuranceRequestWizard = withRouter(connect(
    state => ({
        immAccounts: state.accounts,
        immLoans: state.loans,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immInsuranceLegalDocuments: state.insuranceRequestLegalDocuments,
        immInsuranceState: state.insuranceRequestState,
        immInsuranceWizard: state.insuranceRequestWizard,
        immPreContractualMail: state.preContractualMail,
        immProfile: state.profile,
        immRightsProfile: state.rightsProfile,
        immInsuranceAssociatedMortgage: state.insuranceAssociatedMortgage,
        immInsurances: state.insuranceRequestLanding,
        immInsuranceChosenMortgage: state.insuranceChosenMortgage,
    }),
    {
        changeErrorPopulation: insuranceRequestWizardActions.changeErrorPopulation,
        changeErrorPostalCode: insuranceRequestWizardActions.changeErrorPostalCode,
        clearPostalCodeError: insuranceRequestWizardActions.clearPostalCodeError,
        clearRequest: insuranceRequestWizardActions.clearRequest,
        getAddressTypeList: insuranceRequestWizardActions.getAddressTypeList,
        getBlockedAccounts: blockedAccountsActions.getBlockedAccounts,
        getCoveragesAndPlansData: insuranceRequestWizardActions.getCoveragesAndPlansData,
        getCoveragesAndPlansDetailsData: insuranceRequestWizardActions.getCoveragesAndPlansDetailsData,
        getDocument: insuranceRequestWizardActions.getDocument,
        getDocumentsSummary: insuranceLegalDocumentsActions.getDocumentsSummary,
        getDocumentsZip: insuranceLegalDocumentsActions.getDocumentsZip,
        getInsurance: insuranceRequestStateActions.requestInsuranceCurrentState,
        getMortgageBanks: insuranceRequestActionsWizardStep4.getMortgageBanks,
        getPaymentAccount: insuranceRequestWizardActions.getPaymentAccount,
        getPopulationData: insuranceRequestWizardActions.getPopulationData,
        getQuotationData: insuranceRequestWizardActions.getQuotationData,
        getRecommendation: insuranceRequestStateActions.requestInsuranceRecommendation,
        insuranceSelectPlan: insuranceRequestWizardActions.insuranceSelectPlan,
        insuranceRequestFreeStarted: insuranceRequestStateActions.insuranceRequestFreeStarted,
        insuranceRequesCombinedStarted: insuranceRequestStateActions.insuranceRequesCombinedStarted,
        linkClientSuccessInitialState: insuranceRequestWizardActions.linkClientSuccessInitialState,
        loadSteps: insuranceRequestWizardActions.loadSteps,
        onPrintDocument: insuranceLegalDocumentsActions.onPrintDocument,
        requestInsuranceProvinces: insuranceRequestActionsWizardStep4.requestInsuranceProvinces,
        requestProfile: profileActions.requestProfile,
        resetBlockedAccounts: blockedAccountsActions.resetBlockedAccounts,
        resetPrecontractualMail: preContractualMailActions.resetPrecontractualMail,
        saveStep: insuranceRequestActionsWizardStep4.saveStep,
        sendPreContractualMail: preContractualMailActions.sendInsurancePrecontractualMail,
        setData: insuranceRequestWizardActions.setData,
        setVisibleStep: insuranceRequestWizardActions.setVisibleStep,
        setWillCancel: insuranceRequestWizardActions.setWillCancel,
        validateStep: insuranceRequestWizardActions.validateStep,
        setInsuranceChosenMortgage: insuranceChosenMortgageActions.setInsuranceChosenMortgage,
        getInsuranceAssociatedMortgage,
        requestInsurancesOverallView: insurancesLandingActions.requestInsurancesOverallView,
        getRights: rightsProfileActions.getRights,
        checkReadDocument: insuranceRequestWizardActions.checkReadDocument,
    }
)(InsuranceRequestWizard));
